;(() => {
  // naja
  naja.initialize()

  // headlines
  let active = 3
  const headlines = document.querySelectorAll('.headline-anim')

  const next = () => {
    active++
    if (active > 3) {
      active = 0
    }
    headlines.forEach((headline, index) => {
      if (index === active) {
        headline.classList.add('active')
      } else {
        headline.classList.remove('active')
      }
    })
  }

  headlines[0].addEventListener('animationiteration', next)
  headlines[1].addEventListener('animationiteration', next)
  headlines[2].addEventListener('animationiteration', next)
  headlines[3].addEventListener('animationiteration', next)

  next()

  // blocks
  const blocks = document.querySelectorAll('.block')

  const blockClick = e => {
    e.target.parentElement.parentElement.classList.toggle('clck')
  }

  const windResize = () => {
    if (window.innerWidth <= 580000) {
      blocks.forEach(block => {
        block.addEventListener('click', blockClick)
      })
    } else {
      blocks.forEach(block => {
        block.removeEventListener('click', blockClick)
        block.classList.remove('clck')
      })
    }
  }

  windResize()

  window.addEventListener('resize', windResize)

})()
